module.exports = __webpack_public_path__ + "img/HighPass.f251e9f3.jpg";